module.exports = require("sillyname");


//////////////////
// WEBPACK FOOTER
// external "sillyname"
// module id = 23
// module chunks = 0